module.exports = __webpack_public_path__ + "static/media/28DGC8.583a2210.jpg";